import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";

import { IOrder } from "@src/types/api";

import CancelOrderModal from "@LeagueManagement/Order/components/CancelOrderModal";
import OrderDetails from "@LeagueManagement/Order/components/OrderDetails";
import OrderHistory from "@LeagueManagement/Order/components/OrderHistory";
import ProductDetails from "@LeagueManagement/Order/components/ProductDetails";
import ReinstateOrderModal from "@LeagueManagement/Order/components/ReinstateOrderModal";
import useModalHandlers from "@LeagueManagement/Order/hooks/useModalHandlers";
import useOrderHandlers from "@LeagueManagement/Order/hooks/useOrderHandlers";

const Order = (): React.JSX.Element => {
    const { order: loadedOrder } = useLoaderData() as { order: IOrder };
    const [order, setOrder] = useState<IOrder>(loadedOrder);
    const [orderStatus, setOrderStatus] = useState<IOrder["status"]>(
        order.status,
    );
    const [orderNote, setOrderNote] = useState<string>();

    useEffect(() => {
        setOrderStatus(order.status);
    }, [order.status]);

    const {
        showOrderModal,
        showProductModal,
        handleOrderModalClose,
        handleOrderModalShow,
        handleProductModalClose,
        handleProductModalShow,
        showReinstateOrderModal,
        handleReinstateOrderModalClose,
        handleReinstateOrderModalShow,
    } = useModalHandlers();

    const { handleSubmit, handleOrderUpdate } = useOrderHandlers({
        order,
        setOrder,
        orderStatus,
        orderNote,
        setOrderNote,
    });

    return (
        <section className="orderContent" data-testid="orderContent">
            <Row>
                <Col xs={12} lg={9}>
                    <Row>
                        <OrderDetails
                            order={order}
                            setOrderStatus={setOrderStatus}
                            handleOrderUpdate={() =>
                                handleOrderUpdate(
                                    handleOrderModalShow,
                                    handleOrderModalClose,
                                )
                            }
                            handleReinstateOrderShow={
                                handleReinstateOrderModalShow
                            }
                        />
                        <Col>
                            <h3>Product Details</h3>
                            {order.products
                                ? order.products.map((p, idx) => (
                                      <ProductDetails
                                          key={idx}
                                          product={p}
                                          order={order}
                                          handleClose={() =>
                                              handleProductModalClose(idx)
                                          }
                                          handleShow={() =>
                                              handleProductModalShow(idx)
                                          }
                                          handleSubmit={handleSubmit}
                                          showModal={
                                              showProductModal[idx] || false
                                          }
                                      />
                                  ))
                                : ""}
                        </Col>
                    </Row>
                </Col>
                <Col lg={3} className="mt-4 mt-lg-0">
                    <OrderHistory
                        order={order}
                        orderNote={orderNote}
                        setOrderNote={setOrderNote}
                    />
                </Col>
            </Row>
            <CancelOrderModal
                show={showOrderModal}
                handleClose={handleOrderModalClose}
                handleSubmit={handleSubmit}
            />
            <ReinstateOrderModal
                show={showReinstateOrderModal}
                handleClose={handleReinstateOrderModalClose}
                handleSubmit={handleSubmit}
            />
        </section>
    );
};

export default Order;
